import axiosService from './axiosService';
import authService from './authService';

class RepositoryService {
  allRepositories = () => axiosService.get('/api/repositories');

  getUserRepositories = () => axiosService.get(`/api/repositories/users/${authService.getUserId()}`);

  getRepository = (repositoryId) => axiosService.get(`/api/repositories/${repositoryId}`);

  updateRepository = (data) => axiosService.put(`/api/repositories/${data.id}`, {
    repository: data,
    roles: null,
    databases: null
  });
}

const repositoryService = new RepositoryService();
export default repositoryService;
